import React, { useMemo, useEffect } from 'react';
import { DEFAULT_COVER_BG_SVG, preloadImageUrls, resolveAssetUrl } from './CarreraContinuaAssets';

/**
 * COMPONENTE DE PORTADA PARA PANTALLA GIGANTE: CARRERA CONTINUA (HU-06)
 * Diseño Full HD (1920x1080) limpio sin código QR, enfocado en marcas y ambientación deportiva.
 */
export const CarreraContinuaCover = ({ theme: propTheme, config: propConfig, roomId }) => {
    // 1. Deserialización y consolidación de la configuración del tema
    const resolvedTheme = useMemo(() => {
        if (propTheme && typeof propTheme === 'object') {
            return propTheme;
        }

        if (propConfig) {
            if (propConfig.theme && typeof propConfig.theme === 'object') {
                return propConfig.theme;
            }
            if (propConfig.datosDinamica) {
                try {
                    const parsed = typeof propConfig.datosDinamica === 'string'
                        ? JSON.parse(propConfig.datosDinamica)
                        : propConfig.datosDinamica;
                    return parsed || {};
                } catch (e) {
                    console.warn('[CarreraContinuaCover] Error al parsear datosDinamica:', e);
                }
            }
            return propConfig;
        }

        return {};
    }, [propTheme, propConfig]);

    // Extracción de propiedades visuales
    const coverBackgroundUrl = resolveAssetUrl(resolvedTheme.coverBackgroundUrl) || DEFAULT_COVER_BG_SVG;
    const brandLogoUrl = resolveAssetUrl(resolvedTheme.brandLogoUrl) || null;
    const sponsorLogoUrl = resolveAssetUrl(resolvedTheme.sponsorLogoUrl) || null;
    const coverTitle = resolvedTheme.coverTitle || '¡GRAN CARRERA CONTINUA!';
    const totalKilometers = resolvedTheme.totalKilometers || 5;
    const primaryColor = resolvedTheme.primaryColor || '#dc2626';
    const secondaryColor = resolvedTheme.secondaryColor || '#f59e0b';
    const fontFamily = resolvedTheme.fontFamily || 'Montserrat, sans-serif';

    // Precarga de logos e imágenes de fondo
    useEffect(() => {
        preloadImageUrls([coverBackgroundUrl, brandLogoUrl, sponsorLogoUrl]);
    }, [coverBackgroundUrl, brandLogoUrl, sponsorLogoUrl]);

    return (
        <div
            className="cccover"
            style={{
                fontFamily: fontFamily,
                '--cc-primary': primaryColor,
                '--cc-secondary': secondaryColor
            }}
        >
            {/* FONDO FULL HD / PARALLAX PREVIEW */}
            <div
                className="cccover__bg"
                style={{
                    backgroundImage: `url(${coverBackgroundUrl})`
                }}
            />

            {/* CAPA DE AMBIENTACIÓN Y DESTELLOS DE ESTADIO */}
            <div className="cccover__overlay">
                <div className="cccover__beam cccover__beam--left" />
                <div className="cccover__beam cccover__beam--right" />
                <div className="cccover__stadium-glow" />
            </div>

            {/* CONTENIDO PRINCIPAL DE PORTADA */}
            <div className="cccover__content">
                {/* 1. SECCIÓN DE LOGOS (CLUB / PATROCINADOR) */}
                {(brandLogoUrl || sponsorLogoUrl) && (
                    <div className="cccover__logos-wrapper">
                        {brandLogoUrl && (
                            <div className="cccover__logo-container">
                                <img
                                    src={brandLogoUrl}
                                    alt="Club / Marca"
                                    className="cccover__logo cccover__logo--brand"
                                />
                            </div>
                        )}
                        {brandLogoUrl && sponsorLogoUrl && (
                            <div className="cccover__logo-divider">
                                <span>✕</span>
                            </div>
                        )}
                        {sponsorLogoUrl && (
                            <div className="cccover__logo-container">
                                <img
                                    src={sponsorLogoUrl}
                                    alt="Patrocinador Oficial"
                                    className="cccover__logo cccover__logo--sponsor"
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* 2. BADGE DE DISTANCIA / HITOS */}
                {/* <div className="cccover__badge">
                    <span className="cccover__badge-icon">⚡</span>
                    <span className="cccover__badge-text">
                        DESAFÍO DE {totalKilometers} KILÓMETROS
                    </span>
                    <span className="cccover__badge-icon">⚡</span>
                </div> */}

                {/* 3. TÍTULO DEPORTIVO GIGANTE */}
                <h1 className="cccover__title">
                    {coverTitle}
                </h1>

                {/* 4. LLAMADA A LA ACCIÓN (SIN CÓDIGO QR) */}
                {/* <div className="cccover__cta-card">
                    <div className="cccover__cta-pulse" />
                    <p className="cccover__cta-text">
                        ¡PREPÁRATE EN TU DISPOSITIVO MÓVIL!
                    </p>
                    <span className="cccover__cta-subtext">
                        Elige tu zona, calienta los dedos y corre a máxima velocidad al iniciar el conteo
                    </span>
                </div> */}

                {/* 5. VISTA PREVIA DE PISTA / SILUETAS ATLETICAS */}
                {/* <div className="cccover__track-preview">
                    <div className="cccover__lane-line" />
                    <div className="cccover__runner-silhouette cccover__runner-silhouette--1" />
                    <div className="cccover__runner-silhouette cccover__runner-silhouette--2" />
                    <div className="cccover__runner-silhouette cccover__runner-silhouette--3" />
                </div> */}
            </div>

            {/* PIE DE PÁGINA INSTITUCIONAL */}
            <footer className="cccover__footer">
                <p className="cccover__credits" style={{ fontSize: '1.6em', color: '#ffffff' }}>
                    Hecho con ♥ por Interaktia | 2026
                </p>
            </footer>
        </div>
    );
};

export default CarreraContinuaCover;
